import { Container } from '@educator/components/ProgramSections/Container'
import { InlineCta } from '@educator/components/ProgramSections/InlineCta'
import { PROGRAM_SECTIONS_I18N_NAMESPACE } from '@educator/components/ProgramSections/i18n'
import type {
  CtaSectionData,
  ProgramSectionContext,
} from '@educator/components/ProgramSections/types/sections'
import { useEnrollmentBanner } from '@educator/hooks/useEnrollmentBanner'
import { useTranslation } from '@mc/i18n'

const CTA_LOCATION = 'cta band'

interface CtaSectionProps extends ProgramSectionContext {
  data: CtaSectionData
}

export const CtaSection = ({ data, initialCohortDetails }: CtaSectionProps) => {
  const { t } = useTranslation(PROGRAM_SECTIONS_I18N_NAMESPACE)
  const { heroStrip, currentCohortName, nextCohortName } =
    useEnrollmentBanner(initialCohortDetails)

  const cohortName = {
    applications: currentCohortName,
    nextCohort: nextCohortName,
    legacy: undefined,
  }[heroStrip.variant]
  const headline = cohortName
    ? t(data.cohortHeadlineKey, { cohortName })
    : t(data.headlineKey)

  return (
    <section data-section='cta' className='w-full py-6 md:py-12'>
      <Container>
        <InlineCta headline={headline} ctaLocation={CTA_LOCATION} />
      </Container>
    </section>
  )
}
